import {Button} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import AddNewFilterModal from './Modal/AddNewFilterModal'
import DeleteFilterTextModal from './Modal/DeleteFilterTextModal'
import {useSpamFilterProvider} from './SpamFIlterProvider'
import TableContent from '../../utils/components/Table/TableContent'
import {SpamFilterColumn} from './SpamFilterColumn'
import {KTIcon} from '../../../_metronic/helpers'
import Filter from './Filter'
import TablePagination from '../../utils/components/Table/TablePagination'
import {
  ListViewContext,
  ListViewProvider,
  useListView,
} from '../../utils/contextProvider/ListViewProvider'
import SelectList from '../../utils/components/SelectList'
import {Helmet} from 'react-helmet-async'
import InputSearchBox from '../../utils/components/form/InputSearchBox'

const SpamFilterContent = () => {
  const {
    isLoading,
    setUpdateSpamText,
    filteredSpam,
    totalElement,
    itemsPerPage,
    currentPage,
    handlePageChange,
    searchTerm,
    setSearchTerm,
  } = useSpamFilterProvider()

  const {selected} = useListView()

  return (
    <div>
      <Helmet>
        <title>Spam Filter</title>
      </Helmet>
      <h3 className='er mb-4 fs-2x fw-medium'>
        Spam Filter <span className='form-text'></span>
      </h3>

      <div className='d-flex gap-4 flex-wrap justify-content-between align-items-center mb-6'>
        <InputSearchBox
          placeholder='Search'
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />

        <div className='d-flex gap-2 flex-wrap'>
          {selected.length > 0 ? (
            <SelectList context={ListViewContext} />
          ) : (
            <>
              <Filter />
              <button type='button' className='btn btn-success me-3'>
                <KTIcon iconName='exit-up' className='fs-2' />
                Export
              </button>
              <button
                type='button'
                className='btn btn-primary'
                data-bs-toggle='modal'
                data-bs-target='#kt_modal_1'
                onClick={() => setUpdateSpamText(undefined)}
              >
                <KTIcon iconName='plus' className='fs-2' />
                Create New Filter
              </button>
            </>
          )}
        </div>
      </div>

      <div className='card mb-5 mb-xl-10'>
        <TableContent
          isLoading={isLoading}
          tableData={filteredSpam}
          tableColumn={SpamFilterColumn}
          className='text-center'
        >
          <TablePagination
            totalElement={totalElement}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
            isLoading={isLoading}
          />
        </TableContent>
      </div>

      <AddNewFilterModal />
      <DeleteFilterTextModal />
    </div>
  )
}

const SpamFilter = () => {
  const {isLoading, filteredSpam} = useSpamFilterProvider()

  return (
    <ListViewProvider isLoading={isLoading} data={filteredSpam}>
      <SpamFilterContent />
    </ListViewProvider>
  )
}

export default SpamFilter
